import PropTypes from 'prop-types';

const titleTable = ['id', 'checkCode', 'groupName', 'discountValue', 'maxDiscountValue', 'minOrderValue', 'maxOrderValue', 'limitNumberOfTimes', 'salePrice', 'status', 'hmsVerificationCode', 'createdDate', 'voucherType', 'usedCount', 'startDate', 'endDate', 'propertyOfStay', 'checkInDate', 'checkOutDate', 'operaBookingCode', 'checkedDate'];
// export const Model = {
//     id: PropTypes.string,
//     name: PropTypes.string,
//     email: PropTypes.string,
//     role: PropTypes.string,
//     password: PropTypes.string,
//     status: PropTypes.bool,
// };
export default {titleTable}
